export const errors = {
  "403": "No tienes acceso a esta página.",
  "404": "Esta página no parece existir.\nPuede que haya sido eliminada o movida.",
  "500": "La aplicación ha encontrado un error desconocido. Inténtalo de nuevo en unos momentos.",
  "502": "Algo salió mal. Inténtalo de nuevo en unos momentos.",
  "403_action": "No tienes permiso para realizar esta acción.",
  "404_action": "Este objeto no existe.\nPuede que haya sido eliminado o movido.",
  authError: "Se produjo un error durante el flujo de inicio de sesión. Inténtalo de nuevo.",
  authLinkError:
    "Algo malo paso. Probablemente utilizó la URL incorrecta para acceder a esta página. Vuelve a casa e inténtalo de nuevo.",
  fetch_error: "La red es inalcanzable. Inténtalo de nuevo en unos momentos.",
  incorrect_url: "Esta URL es incorrecta.",
  no_tenant: "Deberías contactar al administrador.",
  superadmin_no_tenant: "Debes elegir primero al inquilino o establecer el predeterminado.",
  Take_me_home: "Llévame a casa",
  Try_again: "Intentar otra vez",
  unknown: "La aplicación ha encontrado un error desconocido. Inténtalo de nuevo en unos momentos.",
  if_error_persists: "Si el error persiste, por favor contacta al <a>equipo de soporte</a>",
  mapping_download_error: "Error al descargar el archivo de mapeo. Por favor, inténtalo de nuevo más tarde.",
} as const;
